<script>
import MultipleChoiceQuestion from "./QuestionTypes/MultipleChoiceQuestion.vue"
import TrueFalseQuestion from "./QuestionTypes/TrueFalseQuestion.vue"
import YesNoQuestion from "./QuestionTypes/YesNoQuestion.vue"
import axios from "axios";

export default {
    name: "quiz-progress",
    computed: {
        label: function() {
            if (this.progress.data.progress === 0) {
                return '';
            }
            return this.progress.data.numberOfAnswered + "/" + this.progress.data.numberOfQuestions;
        },
        progressWidth: function() {
            return "width: " + this.progress.data.progress + "%;";
        }
    },
    props: {
        progress: {
            type: Object,
            required: true,
            default: () => {
                return {
                    data: {
                        numberOfQuestions: 0,
                        numberOfAnswered: 0,
                        progress: 0
                    }
                }
            }
        }
    }
}
</script>

<template>
    <div
        class="progress"
        role="progressbar"
        aria-label="Quiz Progress"
        :aria-valuenow="progress.data.progress"
        :aria-valuemin="progress.data.numberOfAnswered"
        :aria-valuemax="progress.data.numberOfQuestions"
        style="height: 20px;"
    >
        <div class="progress-bar bg-grey text-primary" :style="progressWidth">{{label}}</div>
    </div>
</template>


